import React, { useState, useRef, useEffect } from 'react';
import { CgLaptop } from "react-icons/cg";
import ScrollReveal from 'scrollreveal';
import AOS from 'aos';
import experiences from './Experience';
import { FaReact } from "react-icons/fa";
import { SiAltiumdesigner } from "react-icons/si";
import '../App.css';
import projects from './projectData';
import { TypeAnimation } from 'react-type-animation';
import ThreeD from '../components/ThreeD';
import AutoPilot from '../components/AutoPilot';
import WorkPage from '../components/my work/work-page';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import ShaderBackground from '../components/ShaderBackground';

const Home = () => {
  const [isToggled, setIsToggled] = useState(false);
  const [sortedExperiences, setSortedExperiences] = useState([]);
  const [showWhiteCard, setShowWhiteCard] = useState(false);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const scrollRef = useRef(null);
  const animationSectionRef = useRef(null);
  const handleToggle = () => {
    setIsToggled(!isToggled);
  };

  const getResumeDownloadUrl = () => {
    const downloadUrl = `https://drive.google.com/file/d/1VZhr74CQOsFBOXrzECpLaRjNgof41L1R/view?usp=drive_link`;
    return downloadUrl;
  };

  useEffect(() => {
    const sorted = [...experiences].sort((a, b) => {
      const dateA = a.startDate || new Date(a.duration.split(' - ')[0]);
      const dateB = b.startDate || new Date(b.duration.split(' - ')[0]);
      return dateB - dateA;
    });
    setSortedExperiences(sorted);
  }, []);

  const ExperienceItem = ({ title, company, duration, description, faq, logoUrl }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [iconRotation, setIconRotation] = useState(0);

    const toggleDescription = () => {
      setIsOpen(!isOpen);
      setIconRotation(isOpen ? 0 : 180);
    };

    return (
      <div className="bg-purple-700 rounded-lg shadow-lg overflow-hidden">
        <div className="px-4 py-5 sm:px-6 flex justify-between items-center">
          <div>
            <h3 className="text-lg leading-6 font-medium text-white">{title}</h3>
          </div>
          <div className="flex gap-2 items-center">
            <p className="text-sm text-white">{duration}</p>
            <p className="text-sm text-blue-200 mr-4">{company}</p>
            <button className="bg-black hover:bg-blue-700 text-white font-bold py-2 px-4  transition-transform duration-300"
              onClick={toggleDescription}
              style={{
                transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
                border: '2px solid white',
                borderRadius: '50%',
              }}
            >
              {isOpen ? '-' : '+'}
            </button>

          </div>
        </div>
        <div className={`px-4 py-1  sm:px-6 transition-height duration-700 ease-out ${isOpen ? 'h-auto py-4' : 'h-0 py-0'}`}>
          <div className="flex justify-between items-start">
            <p className="text-white mb-4">{description}</p>
            {logoUrl && (
              <img src={logoUrl} alt={`${company} logo`} className=" mt-2 w-16 h-16 object-contain ml-4" />
            )}
          </div>
          {isOpen && faq && (
            <div className="faq">
              <h4 className="text-lg leading-6 font-medium text-white mb-2">FAQ</h4>
              <ul className="list-disc list-inside">
                {faq.map((item, index) => (
                  <li key={index} className="text-white mb-2">
                    <strong>{item.question}</strong>
                    <p>{item.answer}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  };

  const ContactSection = ({ isToggled, handleToggle }) => {
    const videoRef = useRef(null);

    useEffect(() => {
      if (videoRef.current) {
        if (isToggled) {
          videoRef.current.play().catch(error => {
            console.error('Video play failed:', error);
          });
        } else {
          videoRef.current.pause();
        }
      }

      // Cleanup function
      return () => {
        if (videoRef.current) {
          videoRef.current.pause();
        }
      };
    }, [isToggled]);
    return (
      <div
        className={`flex flex-col sm:flex-row text-white min-h-screen ${isToggled ? 'sm:min-h-screen' : ''}`}
        style={{ background: 'linear-gradient(90deg, rgba(8,7,7,1) 17%, rgba(28,28,28,1) 42%, rgba(8,7,7,1) 75%, rgba(8,7,7,1) 79%, rgba(8,7,7,1) 85%, rgba(8,7,7,1) 92%)' }}
      >
        {/* Left Side: About Me and Contact Details */}
        <div id='contact' className="w-full sm:w-1/2 flex flex-col justify-center items-start p-8 sm:p-16 border-b sm:border-r border-gray-800">
          <h2 className="text-3xl sm:text-4xl text-[#00ff00] font-bold font-roboto-condensed mb-4 transition-all duration-500 transform hover:scale-105">
            AVAILABLE FOR SELECT FREELANCE OPPORTUNITIES
          </h2>
          <p className="text-lg sm:text-xl font-light font-custom-2 mb-8">
            Have an exciting project you need help with? Send me an email or contact me via instant message!
          </p>
          <div className="space-y-4">
            {/* Existing social links */}
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="mailto:singhdigvijay.work@gmail.com" className="underline-effect">
                digvijay12347@gmail.com
              </a>
            </p>
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="https://m.me/tamal" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Messenger
              </a>
            </p>
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="https://www.linkedin.com/in/singh07digvijay/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                LinkedIn
              </a>
            </p>
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="https://www.instagram.com/panwar.digvijaysingh/?hl=en" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Instagram
              </a>
            </p>
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="https://github.com/Digvijay2347" target="_blank" rel="noopener noreferrer" className="hover:underline">
                Github
              </a>
            </p>
            <p className="text-base sm:text-lg font-custom-3 transition-all duration-300 hover:text-[#00ff00]">
              <a href="/mainabout" rel="noopener noreferrer" className="hover:underline">
                About
              </a>
            </p>
            {/* Add Socialize Button */}
            <div className="mt-8">
              <a href="/socialize">
                <button className='zz'>
                  Socialize
                </button>
              </a>
            </div>
          </div>
        </div>

        {/* Right Side: Toggle Button */}
        <div className={`w-full sm:w-1/2 flex flex-col justify-center items-center p-8 sm:p-2 transition-all duration-2000 relative overflow-hidden min-h-[50vh] sm:min-h-screen ${isToggled ? 'bg-transparent' : 'bg-black'}`}>
          {/* Video Background */}
          <video
            ref={videoRef}
            className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${isToggled ? 'opacity-100' : 'opacity-0'}`}
            loop
            muted
            style={{ zIndex: 1 }}
          >
            <source src="naruto.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Overlay to ensure text readability */}
          <div className={`absolute top-0 left-0 w-full h-full bg-black transition-opacity duration-1000 ${isToggled ? 'opacity-50' : 'opacity-0'}`} style={{ zIndex: 2 }}></div>
          
          {/* Content Container */}
          <div className="relative z-30 flex flex-col items-center">
            <p className={`text-4xl sm:text-6xl font-bold text-center mb-4 ${isToggled ? 'text-white' : 'text-black'}`}>Unleash the Power of Creativity!</p>
            <div className="group mb-5 relative flex justify-center items-center text-zinc-600 text-sm font-bold">
              {/* Website link tooltip */}
              <div className="absolute opacity-0 group-hover:opacity-100 group-hover:-translate-y-[150%] -translate-y-[300%] duration-500 group-hover:delay-500 skew-y-[20deg] group-hover:skew-y-0 shadow-md">
                <div className="bg-white flex items-center gap-1 p-2 rounded-md">
                  <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    height="20px"
                    width="20px"
                    xmlns="http://www.w3.org/2000/svg"
                    className="stroke-blue-600"
                  >
                    <circle strokeLinejoin="round" r="9" cy="12" cx="12"></circle>
                    <path
                      strokeLinejoin="round"
                      d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21"
                    ></path>
                    <path
                      strokeLinejoin="round"
                      d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21"
                    ></path>
                    <path strokeLinejoin="round" d="M3 12H21"></path>
                    <path strokeLinejoin="round" d="M19.5 7.5H4.5"></path>
                    <g filter="url(#filter0_d_15_556)">
                      <path strokeLinejoin="round" d="M19.5 16.5H4.5"></path>
                    </g>
                    <defs>
                      <filter
                        colorInterpolationFilters="sRGB"
                        filterUnits="userSpaceOnUse"
                        height="3"
                        width="17"
                        y="16"
                        x="3.5"
                        id="filter0_d_15_556"
                      >
                        <feFlood result="BackgroundImageFix" floodOpacity="0"></feFlood>
                        <feColorMatrix
                          result="hardAlpha"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          type="matrix"
                          in="SourceAlpha"
                        ></feColorMatrix>
                        <feOffset dy="1"></feOffset>
                        <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
                        <feColorMatrix
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                          type="matrix"
                        ></feColorMatrix>
                        <feBlend
                          result="effect1_dropShadow_15_556"
                          in2="BackgroundImageFix"
                          mode="normal"
                        ></feBlend>
                        <feBlend
                          result="shape"
                          in2="effect1_dropShadow_15_556"
                          in="SourceGraphic"
                          mode="normal"
                        ></feBlend>
                      </filter>
                    </defs>
                  </svg>
                  <span>singhdigivijay.com</span>
                </div>
                <div
                  className="shadow-md bg-purple-200 absolute bottom-0 translate-y-1/2 left-1/2 translate-x-full rotate-45 p-1"
                ></div>
                <div
                  className="rounded-md bg-white group-hover:opacity-0 group-hover:scale-[115%] group-hover:delay-700 duration-500 w-full h-full absolute top-0 left-0"
                >
                  <div
                    className="border-b border-r border-white bg-black absolute bottom-0 translate-y-1/2 left-1/2 translate-x-full rotate-45 p-1"
                  ></div>
                </div>
              </div>
            </div>

            {/* Toggle switch */}
            <div className="checkbox-wrapper-25">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={isToggled}
                onChange={handleToggle}
              />
            </div>

            {/* Card */}
            {isToggled && (
              <div className="card mt-6 z-10">
                <div className="top-section">
                  <div className="border"></div>
                  <div className="icons">
                    <div className="logo">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 94 94" className="svg">
                        <path fill="white" d="M38.0481 4.82927C38.0481 2.16214 40.018 0 42.4481 0H51.2391C53.6692 0 55.6391 2.16214 55.6391 4.82927V40.1401C55.6391 48.8912 53.2343 55.6657 48.4248 60.4636C43.6153 65.2277 36.7304 67.6098 27.7701 67.6098C18.8099 67.6098 11.925 65.2953 7.11548 60.6663C2.37183 56.0036 3.8147e-06 49.2967 3.8147e-06 40.5456V4.82927C3.8147e-06 2.16213 1.96995 0 4.4 0H13.2405C15.6705 0 17.6405 2.16214 17.6405 4.82927V39.1265C17.6405 43.7892 18.4805 47.2018 20.1605 49.3642C21.8735 51.5267 24.4759 52.6079 27.9678 52.6079C31.4596 52.6079 34.0127 51.5436 35.6268 49.4149C37.241 47.2863 38.0481 43.8399 38.0481 39.0758V4.82927Z"></path>
                        <path fill="white" d="M86.9 61.8682C86.9 64.5353 84.9301 66.6975 82.5 66.6975H73.6595C71.2295 66.6975 69.2595 64.5353 69.2595 61.8682V4.82927C69.2595 2.16214 71.2295 0 73.6595 0H82.5C84.9301 0 86.9 2.16214 86.9 4.82927V61.8682Z"></path>
                        <path fill="white" d="M2.86102e-06 83.2195C2.86102e-06 80.5524 1.96995 78.3902 4.4 78.3902H83.6C86.0301 78.3902 88 80.5524 88 83.2195V89.1707C88 91.8379 86.0301 94 83.6 94H4.4C1.96995 94 0 91.8379 0 89.1707L2.86102e-06 83.2195Z"></path>
                      </svg>
                    </div>
                    <div className="social-media text-white">
                      <a href="https://www.instagram.com/panwar.digvijaysingh/?hl=en" target="_blank" rel="noopener noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" className="svg">
                          <path d="M 9.9980469 3 C 6.1390469 3 3 6.1419531 3 10.001953 L 3 20.001953 C 3 23.860953 6.1419531 27 10.001953 27 L 20.001953 27 C 23.860953 27 27 23.858047 27 19.998047 L 27 9.9980469 C 27 6.1390469 23.858047 3 19.998047 3 L 9.9980469 3 z M 22 7 C 22.552 7 23 7.448 23 8 C 23 8.552 22.552 9 22 9 C 21.448 9 21 8.552 21 8 C 21 7.448 21.448 7 22 7 z M 15 9 C 18.309 9 21 11.691 21 15 C 21 18.309 18.309 21 15 21 C 11.691 21 9 18.309 9 15 C 9 11.691 11.691 9 15 9 z M 15 11 A 4 4 0 0 0 11 15 A 4 4 0 0 0 15 19 A 4 4 0 0 0 19 15 A 4 4 0 0 0 15 11 z"></path>
                        </svg>
                      </a>
                      <a href="https://your-twitter-link.com" target="_blank" rel="noopener noreferrer">
                        <svg className="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                        </svg>
                      </a>
                      <a href="https://your-discord-link.com" target="_blank" rel="noopener noreferrer">
                        <svg className="svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                          <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"></path>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="bottom-section">
                  <span className="font-bold title">DIGVIJAY SINGH</span>
                  <div className="row row1">
                    <div className="item">
                      <span className="big-text">2000+ hrs</span>
                      <span className="regular-text">Working Time</span>
                    </div>
                    <div className="item">
                      <span className="big-text">100%</span>
                      <span className="regular-text">Reliability</span>
                    </div>
                    <div className="item">
                      <span className="big-text">1000+</span>
                      <span className="regular-text">Contributions</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  useEffect(() => {

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        // Start the animation when the section is visible
        animationSectionRef.current.classList.add('animate');
      }
    }, { threshold: 1.0 });

    // Ensure animationSectionRef.current is defined before observing
    if (animationSectionRef.current) {
      observer.observe(animationSectionRef.current);
    }



    AOS.init();

    ScrollReveal().reveal('.rocket-image', { delay: 300, origin: 'left', distance: '100px', duration: 1000 });
    ScrollReveal().reveal('.caraousal', { delay: 300, origin: 'left', distance: '100px', duration: 1000 });
    ScrollReveal().reveal('.specialized', { delay: 300, origin: 'left', distance: '100px', duration: 1000, reset: false });
    ScrollReveal().reveal('.beautiful', { delay: 300, origin: 'right', distance: '100px', duration: 1000, reset: false });
    ScrollReveal().reveal('.crazy', { delay: 300, origin: 'left', distance: '100px', duration: 1000, reset: true });
    ScrollReveal().reveal('.creative', { delay: 300, origin: 'right', distance: '100px', duration: 1000, reset: true });
    ScrollReveal().reveal('.shit', { delay: 300, origin: 'left', distance: '100px', duration: 1000, reset: true });
    ScrollReveal().reveal('.expertise', { delay: 300, origin: 'bottom', distance: '100px', duration: 1000, reset: true });

  }, []);

  // State variables for selected filters
  const [selectedCategory, setSelectedCategory] = useState('');

  // Function to filter projects
  const filterProjects = (project) => {
    if (!selectedCategory || project.category === selectedCategory) {
      return true;
    }
    return false;
  };

  // Event handlers to update selected filters
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };
  const filterVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  const scrollToElement = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 1
  };
  const dialerInfo = {
    1: {
      title: "Software Development",
      description: "Experienced in both functional and OOP: Dart, Python, Java, JavaScript, TypeScript."
    },
    2: {
      title: "Frontend Dev React, NextJS",
      description: "Passionate about UI/UX. Over 2 years of development experience in HTML, CSS, JS, React and NextJS frameworks."
    },
    3: {
      title: "Open Source",
      description: "Leveraging extensive experience in contributing to and managing open source projects, ensuring high-quality, collaborative development."
    }
  };
  return (
    <>
      <section
        id="home"
        className="relative overflow-hidden w-full"
        style={{ background: '#000' }}
      >
        <div className="relative flex flex-col justify-center items-center min-h-screen bg-cover bg-center">
          {/* Central Image as background - no effects */}
          <div className="absolute inset-0 flex justify-center items-center z-0 pointer-events-none select-none">
            <img 
              src="/prof2.png" 
              alt="Digvijay Singh" 
              className="h-full w-auto object-contain"
            />
          </div>

          {/* Text Content - Above the image */}
          <div className="relative z-10 flex flex-col items-center justify-center max-w-screen-lg px-4 py-8 text-center mb-8">
            <div className="">
              <div data-glitch="Digvijay Singh" className="glitch font-bold text-4xl md:text-8xl mb-10">Digvijay Singh</div>
            </div>
            <p className="text-base text-white md:text-lg lg:text-xl mb-8">
              I design and develop #func()%*!--
            </p>
            {/* Auto piolet */}
            <AutoPilot />
            <a href={getResumeDownloadUrl()} target='__blank' download>
              <div className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 mt-4 rounded-full z-900">
                Download Resume
              </div>
            </a>
          </div>

          <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10">
            <button onClick={scrollToElement} className="text-black px-4 py-2 rounded-full shadow-lg relative">
              <div ref={scrollRef} className="mouse"></div>
            </button>
          </div>
        </div>
      </section>



      {/* Section x */}
      <div id='expertise' className="relative overflow-hidden min-h-screen">
        <ShaderBackground/>
        <div className="rrt bg-cover bg-center text-white flex flex-col justify-center items-center py-6 sm:py-10 min-h-screen z-50" style={{ background: 'linear-gradient(90deg, rgba(8,7,7,1) 17%, rgba(28,28,28,1) 42%, rgba(8,7,7,1) 75%, rgba(8,7,7,1) 79%, rgba(8,7,7,1) 85%, rgba(8,7,7,1) 92%)' }}>
          <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-7xl xl:text-8xl font-bold z-50 mb-4 sm:mb-6 font-roboto tracking-tighter text-center px-4 expertise">
            My Expertise
          </h1>

          {/* Animated Stats Card - Only visible on mobile */}
          <div className="sm:hidden outer mb-8">
            <div className="dot"></div>
            <div className="card">
              <div className="ray"></div>
              <div className="line topl"></div>
              <div className="line leftl"></div>
              <div className="line bottoml"></div>
              <div className="line rightl"></div>
              <label htmlFor="toggle" className="toggle-label">
                <input 
                  className="circle" 
                  id="toggle" 
                  name="toggle" 
                  type="checkbox"
                  onChange={(e) => setShowWhiteCard(e.target.checked)}
                />
              </label>
            </div>
          </div>

          {/* White Card - Only visible on mobile when toggled */}
          {showWhiteCard && (
            <div className="sm:hidden relative flex items-center justify-center mb-8 w-[340px] h-[340px] mx-auto" style={{zIndex: 50}}>
              {/* Outer Circle (ring) */}
              <div className="absolute w-[340px] h-[340px] rounded-full border-4 border-gray-300 bg-gradient-to-br from-white/60 to-gray-100/60 z-10 pointer-events-none"></div>
              {/* Main Card (inner circle) */}
              <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-full shadow-[0_0_50px_rgba(0,0,0,0.2)] p-6 w-72 h-72 flex items-center justify-center border-4 border-gray-100 backdrop-blur-sm overflow-hidden z-20">
                {/* Decorative circles */}
                <div className="absolute inset-0 rounded-full overflow-hidden pointer-events-none">
                  <div className="absolute top-0 left-0 w-32 h-32 bg-blue-100 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-50"></div>
                  <div className="absolute bottom-0 right-0 w-32 h-32 bg-purple-100 rounded-full translate-x-1/2 translate-y-1/2 opacity-50"></div>
                </div>
                {/* Content Display - now fits inside the circle */}
                <div className="relative z-10 flex flex-col items-center justify-center text-center w-full h-full px-4 pointer-events-none">
                  {selectedNumber ? (
                    <div className="w-full flex flex-col items-center justify-center animate-fadeIn">
                      <h3 className="text-lg font-bold text-gray-800 mb-2 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent break-words" style={{wordBreak: 'break-word'}}>
                        {dialerInfo[selectedNumber].title}
                      </h3>
                      <p className="text-xs text-gray-600 leading-snug max-w-[170px] break-words" style={{wordBreak: 'break-word'}}>
                        {dialerInfo[selectedNumber].description}
                      </p>
                    </div>
                  ) : (
                    <div className="w-full flex flex-col items-center justify-center animate-pulse">
                      <p className="text-gray-500 font-medium text-xs">Select a number to view details</p>
                    </div>
                  )}
                </div>
                {/* Glowing effect */}
                <div className="absolute inset-0 rounded-full animate-pulse-slow opacity-30 bg-gradient-to-r from-blue-400 to-purple-400 blur-xl pointer-events-none"></div>
              </div>
              {/* Dialer Numbers in the ring */}
              <div className="absolute inset-0 z-30 pointer-events-none">
                {[1, 2, 3].map((num) => {
                  // Place at radius between the two circles (e.g., 155px from center)
                  const angle = (num - 1) * (2 * Math.PI / 3) - Math.PI / 2; // Start from top
                  const radius = 158; // px, slightly increased
                  const x = 170 + radius * Math.cos(angle); // 170 is half of 340 (container size)
                  const y = 170 + radius * Math.sin(angle);
                  return (
                    <div
                      key={num}
                      className="absolute flex items-center justify-center pointer-events-auto"
                      style={{
                        left: `${x}px`,
                        top: `${y}px`,
                        transform: 'translate(-50%, -50%)'
                      }}
                    >
                      <button
                        onClick={() => setSelectedNumber(num)}
                        className={`w-12 h-12 rounded-full flex items-center justify-center text-lg font-bold border-2 transition-all duration-300 shadow-md bg-white/70 backdrop-blur-md
                          ${selectedNumber === num
                            ? 'border-black text-blue-700 scale-110 shadow-lg'
                            : 'border-black text-gray-700 hover:border-blue-300 hover:scale-105'}
                        `}
                      >
                        {num}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {/* Desktop Expertise cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 w-full max-w-sm sm:max-w-7xl relative px-4 sm:px-6 lg:px-8 mx-auto">
            {/* Cards with SVG icons */}
            {[
              {
                icon: <CgLaptop className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />,
                title: "Software Development",
                description: "Experienced in both functional and OOP: Dart, Python, Java, JavaScript, TypeScript."
              },
              {
                icon: <FaReact className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />,
                title: "Frontend Dev React, NextJS",
                description: "Passionate about UI/UX. Over 2 years of development experience in HTML, CSS, JS, React and NextJS frameworks."
              },
              {
                icon: <SiAltiumdesigner className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12" />,
                title: "Open Source",
                description: "Leveraging extensive experience in contributing to and managing open source projects, ensuring high-quality, collaborative development."
              }
            ].map((card, index) => (
              <div key={index} className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-lg z-20 relative border border-white flex flex-col justify-between w-full mx-auto mt-4 sm:mt-10 md:mt-20 hover:transform hover:scale-105 transition-transform duration-300">
                <div className="flex flex-col sm:flex-row items-start mb-3 sm:mb-4 gap-3 sm:gap-4">
                  <div className="flex-shrink-0">{card.icon}</div>
                  <h2 className="text-lg sm:text-xl md:text-2xl font-semibold relative flex-grow">
                    {card.title}
                    <span className="absolute left-0 bottom-0 w-full h-1 bg-pink-500"></span>
                  </h2>
                </div>
                <p className="text-white text-sm sm:text-base md:text-lg font-Roberto">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* New Work Section */}
      <div id='work-section'>
        <WorkPage />
      </div>


      {/* Professional Experience Section */}
      <div id="experience-section" className="relative py-16" style={{ background: 'linear-gradient(90deg, rgba(8,7,7,1) 17%, rgba(28,28,28,1) 42%, rgba(8,7,7,1) 75%, rgba(8,7,7,1) 79%, rgba(8,7,7,1) 85%, rgba(8,7,7,1) 92%)' }}>
        <DotLottieReact
          src="/wave.lottie"
          loop={true}
          autoplay={true}
          className="absolute inset-0 w-full h-full object-cover opacity-30 "
          style={{
            pointerEvents: 'none',
            zIndex: 1,
            mixBlendMode: 'screen'
          }}
        />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 relative z-10">
          <h2 className="re justify-center text-center text-4xl sm:text-7xl font-Roboto font-bold mb-4 text-white">
            Professional
          </h2>
          <h2 className="res justify-center text-center text-4xl sm:text-7xl font-Roboto font-bold mb-8 text-white">
            Experience
          </h2>
          <div className="space-y-6">
            {sortedExperiences.map((experience, index) => (
              <ExperienceItem key={index} {...experience} />
            ))}
          </div>
        </div>
      </div>
      {/* Section 2 */}
      <div className="flex-col sm:flex justify-center items-start min-h-screen bg-cover " style={{ background: 'linear-gradient(90deg, rgba(8,7,7,1) 17%, rgba(28,28,28,1) 42%, rgba(8,7,7,1) 75%, rgba(8,7,7,1) 79%, rgba(8,7,7,1) 85%, rgba(8,7,7,1) 92%)' }}>
        {/* Additional Section */}
        <div className="max-w-6xl p-6 flex">
          <div className="flex-1 mb-6 sm:mb-0">
            <h1 className="text-2xl sm:text-6xl font-bold mb-4 leading-none">
              <span className="specialized block text-white">SPECIALIZED IN</span>
              <span className="beautiful block text-[#00ff00]">BEAUTIFUL</span>
              <span className=" block text-white">CRAZY</span>
              <span className="creative block text-white">CREATIVE</span>
              <span className="shit block text-white">VALUE</span>
            </h1>
            <div className="border-l-4 border-[#ff00ff] pl-4">
              <p className="text-1xl sm:text-2xl text-[#ff00ff]">
                I Make Awesome Code/Design Content And My Creativity Is Off The Charts. Don't Believe Us? Check Our Projects And Don't Be A Stranger, We're Just A Call Away.
              </p>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <img alt="Creative Image" className="w-[200px] h-[200px] sm:w-[300px] sm:h-[400px] sm:top-10 mb-4 sm:mb-0 floating-animation" src="/astro.png" />
          </div>
        </div>
        {/* Carousel */}
      </div>
      {/* Contact Section */}
      <div id='rrs'>
        <ContactSection isToggled={isToggled} handleToggle={handleToggle} />
      </div>
    </>
  );
};
export default Home;
